import React from "react";

const Header = () => {
  return (
    <div className="px-0 sm:px-4 space-y-6 pt-4">
      <h1 className="text-2xl leading-9 font-bold sm:text-3xl text-text1">
        Product lead report
      </h1>
    </div>
  );
};

export default Header;
